module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row well well-sm",
    staticStyle: {
      "border-bottom": "1px solid gray"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-6 "
  }, [_c('h3', {
    staticClass: "text-info",
    staticStyle: {
      "margin-top": "-5px",
      "margin-bottom": "2px"
    }
  }, [_vm._v(_vm._s(_vm.Patient.firstName) + " " + _vm._s(_vm.Patient.middleName) + " " + _vm._s(_vm.Patient.lastName))]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _c('td', [_vm._v(_vm._s(_vm.FormatDate(_vm.Patient.dob)))])]), _vm._v(" "), _c('tr', [_vm._m(1), _c('td', [_vm._v(_vm._s(_vm.Patient.nhsNumber))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('small', [_c('span', [_vm._v(_vm._s(_vm.Patient.addressLine) + "       ")]), _vm._v(" "), _c('span', [_vm._v(", " + _vm._s(_vm.Patient.postCode) + "      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 "
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "height": "100%",
      "display": "inline-block",
      "vertical-align": "bottom",
      "float": "none"
    }
  }, [_c('a', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": _vm.CreateBag
    }
  }, [_vm._v("Create Bag")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-default",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.EditPatient
    }
  }, [_vm._v("Edit Patient")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('BagList', {
    attrs: {
      "status": [10, 20, 30],
      "patient-id": _vm.patientid
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Dob :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Nhs Id :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('small', [_c('strong', [_vm._v("Address :")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Patient Bags")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-656de9f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656de9f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/Patients/PatientDetail.scp.html
// module id = 553
// module chunks = 0